import type { ReactNode } from 'react'

import { useSession } from '@/lib/access'
import { isUnauthorized } from '@/lib/api'

import { SignedOutPage } from './SignedOutPage'
import { useSessionExpiry } from './useSessionExpiry'

/**
 * The shell, or the signed-out page.
 *
 * Only a 401 means "not signed in". Every other failure of the session query —
 * a 503 from a restarting API, a network drop — is a failure to *load* the app
 * and keeps the shell's own error state, because telling someone to sign in
 * when they already are is worse than telling them nothing.
 */
export function SignedOutGate({ children }: { children: ReactNode }) {
  const session = useSession()
  useSessionExpiry()

  if (session.isError && isUnauthorized(session.error)) return <SignedOutPage />
  return <>{children}</>
}
